export default __webpack_public_path__ + "static/media/dynamic-allround-chem-2.d43e0422.jpg";